import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Permission } from "../../core/model/permission";
import { PermissionService } from "../../core/service/permission.service";

@Component({
  selector: "app-add-permission",
  templateUrl: "./add-permission.component.html",
  styleUrls: ["./add-permission.component.scss"],
})
export class AddPermissionComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;

  permission: Permission = new Permission();

  constructor(
    private _router: Router,
    private _permissionService: PermissionService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this._permissionService
      .add(this.permission)
      .pipe(first())
      .subscribe(
        (data) => {
          this.goToList();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/permission");
  }
}
